module.exports = __webpack_public_path__ + "static/media/broomfield-cons.94651e69.png";